import $ from 'jquery';
import React, { PropTypes } from 'react';
import ReactDOMServer from 'react-dom/server';
import { getMaterialTypes, getReferenceUses } from './api';

require('plugins/are-you-sure');

export function edit() {
  const $form = $('.ui.form');

  // Enable dirty form
  $form.areYouSure({
    silent: true,
  });

  // Bind packagings nav and prevent user if form is dirty
  $form.find('a.packagings').on('click', preventIfDirty);

  // Rendering application
  renderApplication();
}

export function renderApplication(isPCO = false) {
  const $workType = $('#workType');
  const $materialType = $('#materialType');
  const $possibleActions = $('#possible-actions');

  const $materialTypeField = $materialType.parent('.field');

  $materialType.addClass('disabled');

  const handleMaterialVisibility = val => {
    if (isPCO) {
      // Loading materials for given work type
      if (val === 'ANNEX_1' || val === 'ANNEX_2') {
        $materialTypeField.hide();
      } else {
        $materialTypeField.show();
        loadMaterials(val);
      }
    } else {
      // Loading materials for given work type
      if (val === 'ANNEX') {
        $materialTypeField.hide();
      } else {
        $materialTypeField.show();
        loadMaterials(val);
      }
    }
  };

  const workTypeValue = $workType.find('input').val();
  if (workTypeValue && workTypeValue.length > 0) {
    handleMaterialVisibility(workTypeValue);
  }

  const onWorkTypeSelected = val => {
    $possibleActions.html('');
    handleMaterialVisibility(val);
  };

  $workType.dropdown({
    onChange: onWorkTypeSelected,
  });
}

const PossibleActions = ({ actions }) => (
  <div className="ui orange message">
    <div className="header">Manipulations possibles</div>
    {actions.map(a => a.label).join(' / ')}
  </div>
);

PossibleActions.propTypes = {
  actions: PropTypes.array.isRequired,
};

function loadMaterials(type) {
  const $materialType = $('#materialType');
  const $possibleActions = $('#possible-actions');

  const materialTypeValue = $materialType.find('input').val();

  $materialType.dropdown('clear');

  const drawMaterial = (value, label) =>
    `<div class="item" data-value="${value}">${label}</div>`;

  const onMaterialTypeSelected = value => {
    if (value) {
      getReferenceUses(value).then(response => {
        // Rendering possible actions
        const content = ReactDOMServer.renderToStaticMarkup(
          <PossibleActions actions={response.actions} />
        );

        $possibleActions.html(content);
      });
    }
  };

  $materialType.removeClass('disabled').addClass('loading');
  getMaterialTypes(type).then(materials => {
    const $menu = $materialType.find('.menu');

    $menu.empty();
    materials.forEach(p => $menu.append(drawMaterial(p.id, p.label)));

    $materialType.removeClass('loading');
    $materialType.dropdown({
      onChange: onMaterialTypeSelected,
    });

    if (materialTypeValue && materialTypeValue.length > 0) {
      $materialType.dropdown('set selected', materialTypeValue);
    }
  });
}

function preventIfDirty(evt) {
  const $target = $(evt.target);

  const $form = $target.closest('.ui.form');
  const url = $target.attr('href');

  if ($form.hasClass('dirty')) {
    evt.preventDefault();
    displayDirtyModal(() => window.location.assign(url));
    return false;
  }

  return true;
}

function displayDirtyModal(onApprove) {
  const $modal = $('.modal.dirty');
  $modal
    .modal({
      onApprove,
    })
    .modal('show');
}



// WEBPACK FOOTER //
// ./src/modules/product/index.js